module.exports = __webpack_public_path__ + "img/web-grid-tile.7fdf8ace.jpg";